import Vue from "vue";

export default {
	state:{
		invoices:[]
	},
	actions:{
		fetchInvoices({ commit, state }){
			Vue.http.get('payments/fetch').then((res)=>{
				let {invoices} = res.body;
				state.invoices = invoices;
			});
		}
	}
}